import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/Domain/utils/cn';

type Props = {
  pathMatch: (pathname: string) => boolean;
  component: JSX.Element;
  zIndex?: number;
  className?: string;
};

export const KeepAliveRenderer = ({ pathMatch, component, className }: Props) => {
  const location = useLocation();

  const show = pathMatch(location.pathname);
  const cached = useRef<JSX.Element | null>(null);

  if (!cached.current) {
    cached.current = component;
  }

  return (
    <div
      className={cn('h-full', className)}
      style={{
        display: show ? 'block' : 'none',
      }}
    >
      {cached.current}
    </div>
  );
};
